<template>
  <CrudList
    title="Rent Trackers"
    storeName="Rent_trakers"
    slot-scope="{ item }"
    sortable
    canSearch
    :canAdd="false"
    :canEdit="false"
    :canDelete="false"
    :canRemove="true"
    next-link="/admin/stay_instructions"
    :breadcrumbs="[
      {
        text: 'Reservas y estadías',
        disabled: false,
        href: '/admin/rent_trakers'
      },
      {
        text: 'Estadias',
        disabled: false,
        href: '#'
      },
    ]"
    :filters="options"
  >
    <template v-slot:head-list-v2="{ }">
      <v-row class="">
        <v-col cols="6">
          <v-select
              v-model="options.status"
              :items="statusOptions"
              label="Estado"
              multiple
              class="select-search max-w-270"
              solo
              elevation="0"
              dense
              hide-details
              append-icon="$caretDownIcon"
          >
            <template slot="no-data">
              <v-alert :value="true">No hay estados disponibles</v-alert>
            </template>
          </v-select>
        </v-col>
        <v-col cols="6">
          <v-select
              label="Tipo de Spot"
              :items="spotTypes"
              item-text="name"
              item-value="value"
              v-model="options.spot_type"
              class="select-search max-w-270"
              solo
              elevation="0"
              dense
              hide-details
              append-icon="$caretDownIcon"
          >
          </v-select>
        </v-col>
      </v-row>

    </template>


  <template v-slot:car="{ item }">
    <v-row align="center" justify="center">
      <v-col cols="12">
        <p>{{ item.driver && item.driver.patent ? item.driver.patent: '' }}</p>
      </v-col>
    </v-row>
  </template>
  <template v-slot:driver="{ item }">
    <v-row align="center" justify="center">
      <v-col cols="12">
        <p>{{ item.driver && item.driver.user ? `${item.driver.user.name || ''} ${item.driver.user.last_name || ''}`: '' }}</p>
      </v-col>
    </v-row>
  </template>

  <template v-slot:spot="{ item }">
  <ExpansionTable :item="item"></ExpansionTable>
   <!--  <v-expansion-panels :key="item.post_id">
  <v-expansion-panel>
    <v-expansion-panel-header>
      {{ item.spot?.alias_id || '' }}
      {{ item.spot?.address || '' }}
      {{ item.spot?.unit || '' }}
      ({{ item.host ? `${item.host.name || ''} ${item.host.last_name || ''}` : '' }})
    </v-expansion-panel-header>

    <v-expansion-panel-content>
      <div class="table-wrapper">
        <v-data-table
          :headers="headers"
          :items="item.data"
          class="elevation-1"
          dense
          disable-pagination
          hide-default-footer
        >
          <template v-slot:item.conductor="{ item }">
            {{ (item.user_car.name || '') + ' ' + (item.user_car.last_name || '') }}
          </template>
          <template v-slot:item.auto="{ item }">
            {{ item.car.patent || '' }}
          </template>
          <template v-slot:item.estado="{ item }">
            {{ item.status }}
          </template>
          <template v-slot:item.motivo_cancelacion="{ item }">
            {{ item.cancel_reason || '' }}
          </template>
          <template v-slot:item.fecha="{ item }">
            {{ formatDateTimeUtc3(item.created_at) }}
          </template>
        </v-data-table>
      </div>
    </v-expansion-panel-content>
  </v-expansion-panel>
</v-expansion-panels> -->
  
  </template>

  <template v-slot:host="{ item }">
    <v-row align="center" justify="center">
      <v-col cols="12">
        <p>{{ item.host && item.host ? `${item.host.name || ''} ${item.host.last_name || ''}`: '' }}</p>
      </v-col>
    </v-row>
  </template>

  <template v-slot:created_at="{ item }">
    <v-row>
      <v-col>
        <p>{{ formatDateTimeUtc3(item.created_at) }}</p>
      </v-col>
    </v-row>
  </template>
  <template v-slot:updated_at="{ item }">
    <v-row>
      <v-col>
        <p>{{ formatDateTimeUtc3(item.updated_at) }}</p>
      </v-col>
    </v-row>
  </template>
    <template v-slot:conversation="{ item }">
      <div class="text-center">
      <v-btn
          color="primary"
          small
          @click="goToMessages(item.rent_order_id)"
      >
        <v-icon small color="info">
          fas fa-comment
        </v-icon>
      </v-btn>
      </div>
    </template>

  </CrudList>
</template>

<script>
import { mapState } from "vuex";
import CrudList from "@/components/Crud/CrudList";
import CrudFormMixin from "@/mixins/crud_form";
import ExpansionTable from "../../../components/FixedPanel/ExpansionTable.vue";
export default {
  mixins: [CrudFormMixin],
  components: { CrudList,ExpansionTable },
  watch: {
    "data.spot_type": {
      handler(val) {
        this.options.spot_type = val; // sincroniza con options
      },
    },
    options: {
      handler(val) {
        const values = Object.keys(this.data);
        const keys_options = Object.keys({ ...val });
        for (const key of values) {
          if (keys_options.includes(key.toString()) && val[key] !== null) {
            this.data[key] = val[key];
          }
        }
      },
      deep: true,
    },
  },
  computed: {
    ...mapState({
      options: (state) => state.Trakers.options,
    }),
  },
  created() {
  },
  data() {
    return {
      storeName: "Trakers",
      labelDelete: "Eliminar",
      titleDeleted: "Eliminar el registro",
      descriptionDeleted: "¿Quieres eliminar este registro?",
      labelModalConfirm: "Confirmar",
      labelModalCancel: "Cancelar",
      selected_item: "",
      confirmDelete: false,
      headers: [
      { text: 'Conductor', value: 'conductor', align: 'start', sortable: false },
      { text: 'Auto', value: 'auto',sortable: false },
      { text: 'Estado', value: 'estado',sortable: false },
      { text: 'Motivo de cancelación', value: 'motivo_cancelacion',sortable: false },
      { text: 'Unidad', value: 'motivo_cancelacion',sortable: false },
      { text: 'Tiempo', value: 'motivo_cancelacion',sortable: false },
      { text: 'Fecha', value: 'fecha',sortable: false },
    ],
      options: {
        status: []
      },
      statusOptions: [
        { text: "Navegación", value: "pending" },
        { text: "En curso", value: "accepted" },
        { text: "Finalizada", value: "finished" },
        { text: "Finalizada temprano", value: "early_finish" },
        { text: "Cancelado", value: "cancelled" }
      ],
      spotTypes: [
        { name: "Todos", value: null }, // este permite “deseleccionar”
        { name: "Casas", value: "casas" },
        { name: "Parking", value: "parking" }
      ],
    };
  },
  methods: {
    goToMessages(trackerId) {
      // this.$router.push({ name: 'rent_traker_messages', params: { rent_traker_id: trackerId } });
      console.info("goToMessages", trackerId);
      this.$router.push(`rent_trakers/${trackerId}/messages`);
    }
  },
};
</script>
